// extracted by mini-css-extract-plugin
export default {"wishListHover":"NavBar_wishListHover__s6HXn"};